<img *ngIf="!!svgPath" class="tiny-icon" [src]="svgPath" alt=""
     [ngClass]="{'small-icon': size === 'small', 'em-is-disabled': isDisabled}"/>
<span *ngIf="!svgPath">
    <svg class="tiny-icon" [ngClass]="{'small-icon': size === 'small', 'em-is-disabled': isDisabled}">
        <use xmlns:xlink="http://www.w3.org/1999/xlink"
             [attr.xlink:href]="svgPath ? svgPath : 'assets/unity-1.2.0/images/em-icons.svg#' + unitySvgName"></use>
    </svg>
</span>
